import React from "react";
import { Link } from "react-router";

function TabNavigation(props) {
  const {
    updateSidebar,
    currentUrl,
    currentBaseUrl,
    roundInUrl,
    currentRound,
    isMobile
  } = props;

  let suffix = "";
  if (roundInUrl !== null && roundInUrl !== currentRound) {
    suffix = `?round=${roundInUrl}`;
  }

  const emptyClass = isMobile ? "col-xs-4" : "";
  const activeClass = isMobile ? "active col-xs-4" : "active";
  const navClass = isMobile ? "row text-center" : "nav-justified";

  return (
    <ul className={`nav nav-tabs ${navClass} mb-20`}>
      <li
        role="presentation"
        className={currentUrl === "IncomeStatement" ? activeClass : emptyClass}
      >
        <Link
          to={`/${currentBaseUrl}/results/FinancialAnalysis${suffix}`}
          onClick={e => updateSidebar("IncomeStatement")}
        >
          <span>Income Statement</span>
        </Link>
      </li>
      <li
        role="presentation"
        className={currentUrl === "BalanceSheet" ? activeClass : emptyClass}
      >
        <Link
          to={`/${currentBaseUrl}/results/FinancialAnalysis/BalanceSheet${suffix}`}
          onClick={e => updateSidebar("BalanceSheet")}
        >
          <span>Balance Sheet</span>
        </Link>
      </li>
      <li
        role="presentation"
        className={currentUrl === "CashFlow" ? activeClass : emptyClass}
      >
        <Link
          to={`/${currentBaseUrl}/results/FinancialAnalysis/CashFlow${suffix}`}
          onClick={e => updateSidebar("CashFlow")}
        >
          <span>Cash Flow</span>
        </Link>
      </li>
    </ul>
  );
}

export default TabNavigation;



// WEBPACK FOOTER //
// ./src/components/results/TabNavigation.js